import { render } from "./ServiceView.vue?vue&type=template&id=469dc097&scoped=true"
const script = {}

import "./ServiceView.vue?vue&type=style&index=0&id=469dc097&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469dc097"]])

export default __exports__